export enum EligiblePromotionType {
    autoship = 'autoship',
}

export type EligiblePromotion = {
    promoId: string;
    promoKey?: string;
    promoText: string;
    order?: number;
    promoStart?: string;
    promoEnd?: string;
    type?: 'autoship';
    default?: boolean;
    discountDisplay?: string;
};
